import { UNIQUENESS_SCORE_PARAMETER } from "helpers/constants/miscellaneous";
import {
  getIsUniquenessFilterEnabled,
  getUniquenessScoreLoading,
  getRemovedElementsByUniquenessCount,
} from "redux/SingleDataset/selectors";
import {
  setUniquenessScoreLoading,
  setRemovedElementsByUniquenessCount,
} from "redux/SingleDataset/actions";
import { useLocation, useNavigate } from "react-router";
import { connect, useDispatch } from "react-redux";
import UniquenessSlider from "./UniquenessSlider";
import { State } from "redux/store";
import { useMemo } from "react";
import FilterButton from "views/atomComponents/FilterButton";
import useQueryParam from "hooks/useQueryParam";

interface UniquenessFilterProps {
  isUniqueFilterEnabled: boolean;
  uniquenessScoreLoading: boolean;
  removedElementsCount: number | null;
}

const UniquenessFilter = ({
  removedElementsCount,
  isUniqueFilterEnabled,
  uniquenessScoreLoading,
}: UniquenessFilterProps) => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const searchParams = useMemo(
    () => new URLSearchParams(location.search),
    [location.search]
  );
  const scoreFromQueryParam = useQueryParam(UNIQUENESS_SCORE_PARAMETER);
  const score = scoreFromQueryParam ? JSON.parse(scoreFromQueryParam) : null;
  const isSelected = score !== null;
  const additionalValue = isSelected ? score : undefined;

  const handleUniquenessChange = (score: number) => {
    dispatch(setUniquenessScoreLoading(true));

    if (!score) {
      searchParams.delete(UNIQUENESS_SCORE_PARAMETER);
      dispatch(setRemovedElementsByUniquenessCount(null));
    } else {
      searchParams.set(UNIQUENESS_SCORE_PARAMETER, JSON.stringify(score));
    }

    navigate({ search: `?${searchParams.toString()}` });
  };

  const handleResetUniqueness = () => {
    searchParams.delete(UNIQUENESS_SCORE_PARAMETER);
    dispatch(setRemovedElementsByUniquenessCount(null));
    dispatch(setUniquenessScoreLoading(true));
    navigate({ search: `?${searchParams.toString()}` });
  };

  return isUniqueFilterEnabled ? (
    <FilterButton
      label={"Select Uniques"}
      variant={isSelected ? "selected" : "default"}
      confidenceLevel={additionalValue}
    >
      <UniquenessSlider
        score={score}
        onReset={handleResetUniqueness}
        removedElementsCount={removedElementsCount}
        handleUniquenessChange={handleUniquenessChange}
        uniquenessScoreLoading={uniquenessScoreLoading}
      />
    </FilterButton>
  ) : (
    <noscript />
  );
};

const mapStateToProps = (state: State) => {
  return {
    removedElementsCount: getRemovedElementsByUniquenessCount(state),
    uniquenessScoreLoading: getUniquenessScoreLoading(state),
    isUniqueFilterEnabled: getIsUniquenessFilterEnabled(state),
  };
};

export default connect(mapStateToProps)(UniquenessFilter);
